<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <Input v-model="searchAppName" style="width:150px;" placeholder="请输入卡片名称"/>
    </div>
    <div class="select-box input_left_two">
      <Input v-model="searchAppVer" style="width:150px;" placeholder="请输入版本号" />
      <Input v-model="searchCardId" style="width:150px;margin-left:24px;" placeholder="请输入卡片ID" />
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <div class="select-box">
      <Button type="primary" @click="newAlert" style="margin-right:5px;">添加卡片</Button>
    </div>
    <div class="app-list-table">
      <Table :loading="tableLoading" ref="selection" @on-selection-change="tableOnSelect" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
      <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    </div>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="batchErrArrFlag"
      title="信息提示"
      @on-ok="clearErrArr()"
    >
    <div v-for="(item,index) in batchErrArr" :key="index">
      {{item.name}}---{{item.message}}
    </div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPush"
      title="批量提交审核"
      @on-ok="editDataPL('formValidatePl')"
      >
      <Form ref="formValidatePl" :model="formValidate" :label-width="120">
        <FormItem label="提交审核" prop="name">
          <Input v-model="formValidatePl.ver" placeholder="请输入版本号" />
        </FormItem>
      </Form>
      <div>统计共{{this.tableSelectRow.length}}个应用</div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPublish"
      title="批量发布"
       @on-ok="editDataPL('formValidatePl')"
      >
      <Form ref="formValidatePl" :model="formValidate" :label-width="120">
        <FormItem label="批量发布" prop="name">
          <Input v-model="formValidatePl.ver" placeholder="请输入版本号" />
        </FormItem>
      </Form>
      <div>统计共{{this.tableSelectRow.length}}个应用</div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plBack"
      title="批量回退"
       @on-ok="editDataPL('formValidatePl')"
      >
      <Form ref="formValidatePl" :model="formValidate" :label-width="120">
        <FormItem label="批量回退" prop="name">
          <Input v-model="formValidatePl.ver" placeholder="请输入版本号" />
        </FormItem>
      </Form>
      <div>统计共{{this.tableSelectRow.length}}个应用</div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      :title="editId ? '编辑卡片' : '添加卡片'"
      :loading="loading"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="卡片名称" prop="cardName">
          <Input v-model="formValidate.cardName" maxlength="20" show-word-limit placeholder="请输入卡片，1-20个字" />
        </FormItem>
        <!-- categoryList -->
        <FormItem label="类型" prop="category">
          <Select  style="width:200px" v-model="formValidate.category">
            <Option :value="item.value" v-for="(item,index) in categoryList" :key='index'>{{item.value}}</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="卡片Icon" prop="icon" :rules="[{required: false, message: 'Icon', trigger: 'blur'}]">
          <label class="file-wrap">
            <input class="file-input" type="file" ref="file" accept="image/*" @change="uploadImg('file')" />
            <Button icon="ios-cloud-upload-outline">{{formValidate.icon || '上传'}}</Button>
          </label>
          <div><img v-show="formValidate.icon" :src="formValidate.icon" width="300"></div>
        </FormItem> -->
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" placeholder="备注最大字数为30字" maxlength="30" type="textarea" :rows="4" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../../https'
export default {
  name: 'esApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      mobileApp: [],
      editId: '',
      editItem: '',
      userList: [],
      userInfoId: '',
      searchAppName: '',
      searchAppVer: '',
      searchCardId: '',
      currentIndex: '',
      isShowSpin: false,
      plType: 0,
      plPush: false,
      plPublish: false,
      plBack: false,
      tableSelectRow: [],
      batchErrArr: [],
      batchErrArrFlag: false,
      baseUrl: '',
      formValidatePl: {
        ver: ''
      },
      formValidate: {
        cardName: '',
        remark: '',
        package_name: '',
        icon: '',
        files: '',
        fileName: '',
        pre_pwd: ''
      },
      ruleValidate: {
        cardName: [
          { required: true, message: '请输入卡片名称', trigger: 'blur' },
          { type: 'string', max: 20, min: 1, message: '请输入2-20个字', trigger: 'blur' }
        ],
        apk_pkg: { required: true, pattern: /^[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*$/g, message: '示例：tv.huan.vibes.test' }
      },
      columns: [ // table表格
        // {
        //   type: 'selection',
        //   width: 60,
        //   align: 'center',
        //   fixed: 'left'
        // },
        {
          title: '卡片id',
          key: 'cardId',
          width: 200,
          align: 'center'
        },
        {
          title: '卡片名称',
          key: 'cardName',
          width: 150,
          align: 'center'
        },
        {
          title: '最新版本',
          key: 'maxVersionStr',
          align: 'center',
          width: 100
        },
        {
          title: '类型',
          key: 'category',
          align: 'center',
          width: 100
        },
        {
          title: '备注',
          key: 'remark',
          align: 'center',
          width: 250
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          width: 220,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '70px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path: `/developer/versionCard`,
                      query: {
                        cardName: params.row.cardName,
                        cardId: params.row.cardId
                      }
                    })
                  }
                }
              }, '卡片管理')
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small'
              //   },
              //   style: {
              //     width: '50px',
              //     marginRight: '10px'
              //   },
              //   on: {
              //     click: () => {
              //       this.delItem(params.index)
              //     }
              //   }
              // }, '删除')
            ])
          }
        }
      ],
      mobileData: {
        id: '',
        name: '',
        app_rel: []
      },
      categoryList: [],
      appPkgFlag: false,
      dataSource: [], // table数据源
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1, // 当前页
      t1: 0,
      t2: 0,
      timer: null
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.getCategoryApp()
    this.loadData()
  },
  mounted () {
  },
  methods: {
    tableOnSelect (row) {
      this.tableSelectRow = row
    },
    changePlType () {
      if (this.plType === '1') {
        console.log('批量提交')
        this.plPush = true
      } else if (this.plType === '2') {
        console.log('批量发布')
        this.plPublish = true
      } else if (this.plType === '3') {
        console.log('批量版本回退')
        this.plBack = true
      }
    },
    getCategoryApp () {
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=category_app'
      }).then(res => {
        console.log(res)
        this.categoryList = res.result
      })
    },
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchAppName = ''
      this.searchAppVer = ''
      this.searchCardId = ''
      this.loadData()
    },
    aduitText (val) {
      if (val === 0) {
        return '未提审'
      } else if (val === 1) {
        return '待审核'
      } else if (val === 2) {
        return '审核通过'
      } else if (val === 3) {
        return '审核驳回'
      }
    },
    changeUserId (val) {
      this.searchAppName = ''
      this.searchAppVer = ''
      this.searchCardId = ''
      this.loadData(val)
    },
    clearUserId () {
      this.loadData()
    },
    getUserNameAuth () {
      let userNameAuth = sessionStorage.getItem('user_name_auth')
      if (userNameAuth !== null) {
        this.userList.map(item => {
          if (item.label === userNameAuth) {
            this.userInfoId = item.value
            this.loadData(item.value)
            sessionStorage.removeItem('user_name_auth')
          }
        })
      }
    },
    // 加载tabs列表
    loadData (id = '') {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.current,
        cardName: `*${this.searchAppName}*`,
        maxVersion: this.searchAppVer,
        cardId: `*${this.searchCardId}*`
      }
      this.isShowSpin = true
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/cardGroup/list',
        params: params
      }).then(res => {
        console.log(res)
        this.tableLoading = false
        this.isShowSpin = false
        this.dataList = res.result.records
        this.total = res.result.total
        // this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    onCopy () {

    },
    uploadImg (name) {
      let file = this.$refs[name].files[0]
      this.formValidate.files = file
      this.formValidate.fileName = file.name
    },
    newAlert (index) {
      this.$refs['formValidate'].resetFields()
      if (!isNaN(index)) {
        console.log(index, this.dataList)
        this.formValidate = {
          cardName: this.dataList[index].cardName,
          remark: this.dataList[index].remark,
          category: this.dataList[index].category,
          icon: this.dataList[index].icon,
          files: '',
          fileName: '',
          cardId: this.dataList[index].cardId
        }
        this.editId = this.dataList[index].cardId
        this.editItem = this.dataList[index]
        this.currentIndex = index
      } else {
        this.editId = ''
        this.editItem = ''
        this.formValidate.files = ''
        this.formValidate.icon = ''
      }
      this.newdata = true
    },
    editDataPL (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.tableSelectRow.length === 0) {
            this.plType = '0'
            this.$Message.error('请先选择应用')
            this.tableSelectRow = []
            return
          }
          let arr = []
          this.tableSelectRow.map(item => {
            arr.push(item.id)
          })
          let params = new FormData()
          params.append('ver', this.formValidatePl.ver)
          params.append('type', this.plType)
          params.append('ids', arr)
          https.request({
            method: 'put',
            url: '/v2/es/app/vers/batch',
            data: params
          }).then(res => {
            this.formValidatePl.ver = ''
            this.plType = 0
            this.tableSelectRow = []
            this.loadData()
            let errArr = []
            res.data.map(item => {
              if (item.status !== 1) {
                console.log(item)
                this.dataList.map(dItem => {
                  if (dItem.id === item.id) {
                    errArr.push({
                      name: dItem.name,
                      message: item.message
                    })
                  }
                })
              }
            })
            this.batchErrArr = errArr
            if (errArr.length > 0) {
              this.batchErrArrFlag = true
            }
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    clearErrArr () {
      this.batchErrArrFlag = false
      this.batchErrArr = []
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            if (this.formValidate.cardName.trim().length === 0) {
              this.$Message.error('卡片名称不能为空')
              return
            }
            let params = {
              cardName: this.formValidate.cardName.trim(),
              category: this.formValidate.category,
              remark: this.formValidate.remark
            }
            if (this.editId) {
              params['cardId'] = this.editId
              https.request({
                method: 'put',
                url: 'extscreenapi/plugin/hili/cardGroup/edit',
                data: params
              }).then(res => {
                console.log(res)
                if (res.code === 400) {
                  console.log(res.message)
                  this.$Message.error(res.message)
                  this.newdata = false
                  this.loadData()
                  return
                }
                if (res.code === 500) {
                  this.$Message.error('卡片名称重复')
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            } else {
              https.request({
                method: 'post',
                url: 'extscreenapi/plugin/hili/cardGroup/add',
                data: params
              }).then(res => {
                console.log(res)
                if (res.code === 500) {
                  this.$Message.error('卡片名称重复')
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    // delItem (index) {
    //   this.$Modal.confirm({
    //     title: '提示',
    //     content: '<p class="del-modal-txt">确定要删除 <span>' + this.dataList[index].cardName + '</span> 吗？</p>',
    //     onOk: () => {
    //       https.request({
    //         method: 'GET',
    //         url: '/v1/tvp/del',
    //         params: {
    //           id: this.dataList[index].cardId
    //         }
    //       }).then(res => {
    //         this.$Message.success('删除成功')
    //         if (this.dataList.length === 1 && this.current > 1) this.current -= 1
    //         this.loadData()
    //       }).catch(error => {
    //         this.$Message.error(error)
    //       })
    //     }
    //   })
    // },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .env-btn {
    display: flex;
    justify-content: space-between;
    button {
      width: 140px;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    right: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .select-box-type-pl{
    display: flex;
    position: absolute;
    top: 20px;
    right: 260px;
  }
  .input_left{
    left:207px;
    // left:407px;
  }
  .input_left_two{
    left:380px;
    // left:580px;
  }
  .input_left_three{
    left:735px;
    // left:755px;
  }
  .app_aduit_stats{
    position: absolute;
    top:0px;
    right:0px;
  }
  .app_close_stats{
    position: absolute;
    top:0px;
    left:4px;
  }
  .app-list-table{
    padding:40px 0;
  }
  .agreement_title{
    text-align: center;
    font-size:20px;
    font-weight: bold;
  }
  .agreement_text{
    width:700px;
    // border:1px solid #000;
    height:500px;
    overflow-y: auto;
    margin-left:50px;
  }
  #copyinput{
    position: absolute;
    bottom: -30px;
  }
  .card-spin-container{
        display: inline-block;
        width: 100%;
        height: 100%;
        // position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/esCard/esCard.vue